export default __webpack_public_path__ + "static/media/youtube.dbc4cf2b.svg";